import { Injectable } from '@angular/core';
import { ReprocessService } from '../../core/services/reprocess.service';
import { Actions, concatLatestFrom, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { REPROCESS_API_ACTIONS } from '../actions/reprocess.actions';
import { APPLICATION_REDUCER } from '../reducers/application.reducer';
import { catchError, map, of, switchMap } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class ReprocessEffects {
  constructor(
    private readonly reprocessService: ReprocessService,
    private readonly actions$: Actions,
    private readonly store: Store,
  ) {}

  reprocessServices$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(REPROCESS_API_ACTIONS.reprocess),
      concatLatestFrom(() => this.store.select(APPLICATION_REDUCER.selectDataQueryParam)),
      switchMap(([{ data }, { queryName, value }]) => this.reprocessService.reprocessServices(data, queryName, value)),
      map(() => REPROCESS_API_ACTIONS.success()),
      catchError((error: HttpErrorResponse) => of(REPROCESS_API_ACTIONS.error({ error }))),
    );
  });
}
